/* eslint-disable */
// prettier-ignore
const validations = {
  CPF: `[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}`,
  CNPJ: "/^(d{2})(d{3})(d{3})(d{4})(d{2})/",
  INTEIRO: "/^-?d+$/",
  INTEIRO_NEGATIVO: "/^-d+$/",
  DATA: "/^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]d{4}$/",
  INTEIRO_MAIOR_1900: "19[0-9][0-9]|20[0-9][0-9]|[2-9][0-9][0-9][0-9]",
  ANO_ENTRE_1900_E_ATUAL: getYearBetween(),
  ANO_ENTRE_2005_E_ATUAL:{
    pattern: isYearBetween2005AndCurrentYear,
    title: "O ano deve estar entre 2005 e o ano atual." },
  ANO_ENTRE_2004_E_ATUAL:{
    pattern: isYearBetween2004AndCurrentYear,
    title: "O ano deve estar entre 2004 e o ano atual." },
  NOME_ESCOLA: "^[a-zA-Z0-9ªº. '-]+$",
  NOME_COMPLETO: "^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s ]+$",
  EMAIL: "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}",
  TELEFONE: "(^\d{4,5}\-\d{4})$",
  MES: "0?[1-9]|1[012]",
  DIAS_DO_MES: "0?[1-9]|1[031]",
  ANO_MAIOR_QUE_ATUAL: { pattern: isYearGreaterThanCurrentYear,
    title: "O ano não pode ser maior que o ano atual."
    },
};

function getYearBetween(): string {
  let currentYear = new Date().getFullYear().toString();

  let first = currentYear.substring(2, 3);
  let second = currentYear.substring(3, 4);

  return `^(19[0-9][0-9]|200[0-9]|20[0-${first}][0-9]|20[0-${first}][0-${second}])$`;
}
function isYearBetween2005AndCurrentYear(): string {
  const currentYear = new Date().getFullYear();
  const startYear = 2005;
  const currentYearLastDigits = currentYear % 100;

  return `^(20[0-${currentYearLastDigits.toString()}])$|^(${Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).join("|")})$`;
}
function isYearBetween2004AndCurrentYear(): string {
  const currentYear = new Date().getFullYear();
  const startYear = 2004;
  const currentYearLastDigits = currentYear % 100;

  return `^(20[0-${currentYearLastDigits.toString()}])$|^(${Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).join("|")})$`;
}
function isYearGreaterThanCurrentYear(): string {
  const currentYear = new Date().getFullYear();
  const currentYearLastDigits = currentYear % 100;
  console.log(currentYearLastDigits);

  return `^(20[0-${currentYearLastDigits.toString()}][0-4])$|^(2[1-9][0-9][0-9])$`;
}

export { validations };
